module.exports = __webpack_public_path__ + "img/zg-logo.5533947a.svg";